export const REFERENCE_ID_COLUMNS = [
  'order_id',
  'stock_location_order_id',
  'returned_reception_id',
  'entry_id',
  'extra_work_order_id',
  'location_order_id',
  'batch_id',
] as const;

export type ReferenceIdColumn = (typeof REFERENCE_ID_COLUMNS)[number];

/** Filtros de referencias asociados a la columna Tarea (no pedido) */
export const TASK_REFERENCE_ID_COLUMNS: ReferenceIdColumn[] = [
  'stock_location_order_id',
  'returned_reception_id',
  'entry_id',
  'extra_work_order_id',
  'location_order_id',
];

export const emptyReferenceIdArrays = (): Record<ReferenceIdColumn, string[]> =>
  REFERENCE_ID_COLUMNS.reduce(
    (acc, col) => {
      acc[col] = [];
      return acc;
    },
    {} as Record<ReferenceIdColumn, string[]>,
  );
